const localStorageKeys = {
  JWT_TOKEN: '@BSF_APP:JWT_TOKEN',
  JWT_REFRESH_TOKEN: '@BSF_APP:JWT_REFRESH_TOKEN',
  USER_INFO: '@BSF_APP:USER_INFO',
  COMPANY_BRANCH: '@BSF_APP:COMPANY_BRANCH'
};

export default localStorageKeys;
